module.exports = __webpack_public_path__ + "static/img/logo4.ba5be977.png";